import React from 'react';
import moment from 'moment';

import {
  TooltipText,
  TooltipBox,
  TooltipCard,
  ToolTipBoxText,
} from '../../../../../../components/Tooltip';

import Icon from '../../../../../../components/Icon';

import {
  HeaderContainer,
  HighLightHeaderContainer,
  HeaderTextBlock,
  HighLightedHeaderText,
  HighLightedHeaderWrapper,
  HighLightedHeaderCTE,
  HeaderDatesWrapper,
  HeaderDatesText,
  HeaderStatusWrapper,
  NFAgContainer,
} from './styles';

import {
  PERFORMANCE_ENUM_TRANSKEY,
  PERFORMANCE_COLORS,
  PERFORMANCE_ENUM,
} from '../../../../../../enums/performance-enum';

const Header = ({
  order,
  nf,
  cte,
  performance,
  orderDate,
  tms,
  isNfAg,
  isTablet,
  isDesktop,
  isMobile,
  transportData,
}) => {
  const { scheduled, expectedDate, contractDate, progress } = tms;

  const checkContractDate = value => {
    const getProgressTransport = progress[0]?.stepType === 6;

    if (value) {
      return moment(value).format('DD/MM/YYYY');
    } else if (!value && !getProgressTransport) {
      return '-';
    } else if (!value && getProgressTransport) {
      return 'Transporte não contratado';
    }
    return '-';
  };

  return (
    <HeaderContainer display={isDesktop ? 'flex' : 'block'}>
      <HighLightHeaderContainer isTablet={isTablet} isDesktop={isDesktop}>
        <HighLightedHeaderWrapper extend={!isDesktop} isMobile={isMobile} up>
          <HeaderTextBlock>
            <HighLightedHeaderText title>Pedido</HighLightedHeaderText>
            <HighLightedHeaderText>
              {order ? `${order}` : '-'}
            </HighLightedHeaderText>
          </HeaderTextBlock>
          <HeaderTextBlock>
            <div style={{ display: 'flex' }}>
              <HighLightedHeaderText title>Nota fiscal</HighLightedHeaderText>
              {isNfAg ? <NFAgContainer>AG</NFAgContainer> : null}
            </div>
            <HighLightedHeaderText>{`${nf}`}</HighLightedHeaderText>
          </HeaderTextBlock>
          {!isMobile && <HighLightedHeaderCTE>{`CTE ${cte}`}</HighLightedHeaderCTE>}
        </HighLightedHeaderWrapper>
        {isMobile && <HighLightedHeaderWrapper isMobile={isMobile}>
          <HighLightedHeaderCTE>{`CTE ${cte}`}</HighLightedHeaderCTE>
        </HighLightedHeaderWrapper>}
        {isTablet ? (
          <HeaderStatusWrapper
            isTablet={isTablet}
            color={PERFORMANCE_COLORS[performance]}
          >
            <span>{PERFORMANCE_ENUM_TRANSKEY[performance]}</span>
            {performance === PERFORMANCE_ENUM.ON_TIME_WITH_JUSTIFICATION ||
              performance === PERFORMANCE_ENUM.LATE_RISK_WITH_JUSTIFICATION ||
              performance === PERFORMANCE_ENUM.LATED_WITH_JUSTIFICATION ||
              performance === PERFORMANCE_ENUM.LATE_WITHOUT_JUSTIFICATION ? (
              <TooltipCard width={579}>
                <TooltipText>
                  <Icon name="error2" />
                </TooltipText>
                <TooltipBox>
                  <ToolTipBoxText>
                    Entrega com ocorrência sujeita à validação de abono de
                    performance. Consulte as ocorrências da viagem para mais
                    detalhes.
                  </ToolTipBoxText>
                </TooltipBox>
              </TooltipCard>
            ) : null}
          </HeaderStatusWrapper>
        ) : null}
      </HighLightHeaderContainer>
      {transportData()}
      <HeaderDatesWrapper isMobile={isMobile}>
        <HeaderTextBlock>
          <HeaderDatesText title>Data de solicitação</HeaderDatesText>
          <HeaderDatesText>
            {moment(orderDate).format('DD/MM/YYYY')}
          </HeaderDatesText>
        </HeaderTextBlock>
        <HeaderTextBlock>
          <HeaderDatesText title>Prazo Contratado</HeaderDatesText>
          <HeaderDatesText>{checkContractDate(contractDate)}</HeaderDatesText>
        </HeaderTextBlock>
        <HeaderTextBlock>
          <HeaderDatesText title>Agendamento</HeaderDatesText>
          <HeaderDatesText>
            {scheduled && expectedDate
              ? moment(expectedDate).format('DD/MM/YYYY')
              : '-'}
          </HeaderDatesText>
        </HeaderTextBlock>
        <HeaderTextBlock>
          <HeaderDatesText title>Previsão de entrega</HeaderDatesText>
          <HeaderDatesText>
            {expectedDate ? moment(expectedDate).format('DD/MM/YYYY') : '-'}
          </HeaderDatesText>
        </HeaderTextBlock>
      </HeaderDatesWrapper>
      {isDesktop || isMobile ? (
        <HeaderStatusWrapper
          color={PERFORMANCE_COLORS[performance]}
          isMobile={isMobile}
        >
          <span>{PERFORMANCE_ENUM_TRANSKEY[performance]}</span>
          {performance === PERFORMANCE_ENUM.ON_TIME_WITH_JUSTIFICATION ||
            performance === PERFORMANCE_ENUM.LATE_RISK_WITH_JUSTIFICATION ||
            performance === PERFORMANCE_ENUM.LATED_WITH_JUSTIFICATION ||
            performance === PERFORMANCE_ENUM.LATE_WITHOUT_JUSTIFICATION ? (
            <TooltipCard>
              <TooltipText>
                <Icon name="error2" />
              </TooltipText>
              <TooltipBox>
                <ToolTipBoxText>
                  Entrega com ocorrência sujeita à validação de abono de
                  performance. Consulte as ocorrências da viagem para mais
                  detalhes.
                </ToolTipBoxText>
              </TooltipBox>
            </TooltipCard>
          ) : null}
        </HeaderStatusWrapper>
      ) : null}
    </HeaderContainer>
  );
};

export default Header;
